import styled from 'styled-components';
import SVG from 'react-inlinesvg';
import { themeGet } from '@styled-system/theme-get';
import { useTranslation } from 'react-i18next';

import { ThreeDotsMenu } from '../../../../assets';
import useDropdown from '../../../../lib/hooks/useDropdown';
import Modal from '../../../../shared/Modal/Modal.jsx';
import ModalConfirmation from '../../../../shared/ModalConfirmation/ModalConfirmation.jsx';
import { useDeletePostMutation } from './hooks/usePostMutation';
import Text from '../../../../shared/Text';

export const PostMenu = ({ campaignId, postId }) => {
  const { t } = useTranslation('posts');
  const { deletePostMutation } = useDeletePostMutation();

  const deletePostModal = () =>
    Modal({
      component: (
        <ModalConfirmation
          variant="error"
          header={t('removeModal.headerText')}
          body={t('removeModal.bodyText')}
          cancelText={t('removeModal.cancel')}
          submitText={t('removeModal.submit')}
          onSave={() => deletePostMutation({ campaignId, postId })}
        />
      ),
      width: '520px',
      padding: '17px',
    });

  const {
    dropdownRef,
    buttonRef,
    showDropdown,
    setShowDropdown,
  } = useDropdown();

  return (
    <Container>
      <IconWrapper
        onClick={() => setShowDropdown(state => !state)}
        ref={buttonRef}
      >
        <MenuIcon src={ThreeDotsMenu} />
      </IconWrapper>
      {showDropdown && (
        <Menu ref={dropdownRef}>
          <Item onClick={() => deletePostModal()}>
            <TrashIcon />
            <Text variant="small2">{t('postMenu.delete')}</Text>
          </Item>
        </Menu>
      )}
    </Container>
  );
};

const IconWrapper = styled.div`
  padding: 10px;
  cursor: pointer;
  border-radius: 50%;

  &:hover {
    background: ${themeGet('colors.primary.20')};
  }
`;

const Container = styled.div`
  position: relative;
  margin-left: 10px;
`;

const MenuIcon = styled(SVG)`
  width: 16px;
  height: 16px;
`;

const Menu = styled.ul`
  position: absolute;
  right: 10px;
  top: 40px;
  box-shadow: 0px 0px 8px rgba(37, 40, 43, 0.12);
  border-radius: 8px;
  width: 140px;
  background: white;
  z-index: 1;
`;

const Item = styled.li`
  padding: 16px 20px 16px;
  cursor: pointer;

  &:hover {
    background: ${themeGet('colors.primary.10')};
  }
`;

const TrashIcon = styled.i.attrs({
  className: 'fa-light fa-trash',
})`
  margin-right: 6px;
`;
